import React from 'react';
import { GenericErrorPage } from 'components/error-pages/generic';

export const ErrorPage: React.FC = () => <GenericErrorPage />;
